import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {ScoresListWidgetFetchHandler} from "./scores-list-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {LiveSwitchClickHandler} from "../../../core/handlers/live-switch-click.handler";
import {LineupsClickEventHandler} from "../../../core/handlers/lineups.click-event.handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {ScoresListWidgetShowAllClickHandler} from "./scores-list-widget.show-all-click.handler";
import {ScoresListWidgetCompetitionsFetchHandler} from "./scores-list-widget.competitions-fetch-handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {StandingsClickEventHandler} from "../../../core/handlers/standings-click-event.handler";
import {ScoresListMatchDetailsClickHandler} from "../../../core/handlers/scores-list-match-details-click.handler";
import {ScoresListWidgetStatePopulation} from "./scores-list-widget.state-population";
import {PopulateSponsorshipBookmakerHandler} from "../../../core/handlers/populate-sponsorship-bookmaker.handler";
import {WidgetLoadedEventHandler} from "../../../core/handlers/widget-loaded-event.handler";
import {ScoresListWidgetDisplayEventHandler} from "./scores-list-widget.display-event.handler";

export class ScoresListWidgetHandlers extends HandlerList {

  static injectables = [
    ScoresListWidgetStatePopulation,
    ScoresListWidgetFetchHandler,
    ScoresListWidgetCompetitionsFetchHandler,
    ScoresListWidgetShowAllClickHandler,
    ScoresListMatchDetailsClickHandler,
    ScoresListWidgetDisplayEventHandler,
    TimingHandler,
    LiveSwitchClickHandler,
    LineupsClickEventHandler,
    PopulateDataHandler,
    EntityClickEventHandler,
    StandingsClickEventHandler,
    PopulateSponsorshipBookmakerHandler,
    WidgetLoadedEventHandler
  ];


  constructor(
    scoresListWidgetStatePopulation: ScoresListWidgetStatePopulation,
    scoresListWidgetFetchHandler: ScoresListWidgetFetchHandler,
    scoresListWidgetCompetitionsFetchHandler: ScoresListWidgetCompetitionsFetchHandler,
    scoresListWidgetShowAllClickHandler: ScoresListWidgetShowAllClickHandler,
    scoresListWidgetMatchDetailsClickHandler: ScoresListMatchDetailsClickHandler,
    scoresListWidgetDisplayEventHandler: ScoresListWidgetDisplayEventHandler,
    timingHandler: TimingHandler,
    liveSwitchClickEventHandler: LiveSwitchClickHandler,
    lineupsClickEventHandler: LineupsClickEventHandler,
    populateDataHandler: PopulateDataHandler,
    entityClickEventHandler: EntityClickEventHandler,
    standingsClickEventHandler: StandingsClickEventHandler,
    populateSponsorshipBookmakerHandler: PopulateSponsorshipBookmakerHandler,
    widgetLoadedEventHandler: WidgetLoadedEventHandler
  ) {
    super();

    [
      scoresListWidgetStatePopulation,
      scoresListWidgetFetchHandler,
      scoresListWidgetCompetitionsFetchHandler,
      scoresListWidgetShowAllClickHandler,
      scoresListWidgetMatchDetailsClickHandler,
      scoresListWidgetDisplayEventHandler,
      timingHandler,
      liveSwitchClickEventHandler,
      lineupsClickEventHandler,
      populateDataHandler,
      entityClickEventHandler,
      standingsClickEventHandler,
      populateSponsorshipBookmakerHandler,
      widgetLoadedEventHandler
    ].forEach(handler => this.add(handler));
  }
}
